import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Sidebar from "../../components/common/Sidebar";
import Header from "../../components/common/Header";
import client from "../../services/Client";
import Loading from "../../components/loader/Loading";
import arrowLeft from "../../asessts/Images/arrow_left.svg";
import { formatRole } from "../../utils/common";
import ImagePreviewModal from "../../components/common/ImagePreviewModal";
const FacilityLabDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [labData, setLabData] = useState({});
  const [selectedImage, setSelectedImage] = useState(null);

  const fetchLabDetail = async () => {
    setIsLoading(true);
    try {
      const response = await client.get(
        `/admin/healthFacility/get-laboratory/${id}`
      );
      setLabData(response?.data?.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching laboratory details:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchLabDetail();
    }
  }, [id]);

  return (
    <>
      <div className="admin-dashboard">
        <Sidebar />
        <div className="main-dashboard subadmin-dashboard">
          <Header
            title={
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <img
                  src={arrowLeft}
                  alt="Back"
                  style={{ cursor: "pointer", width: "22px", height: "22px" }}
                  onClick={() => navigate(-1)}
                />
                <span>Laboratory Details</span>
              </div>
            }
          />
          {isLoading ? (
            <Loading />
          ) : (
            <div>
              <div className="setting-main request-main">
                <div className="setting-details">
                  <div className="basic-detail">
                    <div className="profile-upload">
                      <div className="profile-img">
                        <img src={labData?.information?.image} alt="" />
                      </div>
                    </div>
                    <div className="profile-details">
                      <div className="profile-head">
                        <div>
                          <h2>
                            {labData?.user?.firstName}
                            {labData?.user?.lastName}
                          </h2>
                          <p>
                            <span>Profile ID:</span> {labData?.profileId}
                          </p>
                        </div>
                      </div>
                      <div className="input-group">
                        <div className="input-field">
                          <label>Type</label>
                          <input
                            type="text"
                            placeholder="Type"
                            value={
                              formatRole(labData?.facilityOrProfession) || "--"
                            }
                            readOnly
                          />
                        </div>
                        <div className="input-field">
                          <label>Role</label>
                          <input
                            type="text"
                            placeholder="role"
                            value={formatRole(labData?.role) || "--"}
                            readOnly
                          />
                        </div>
                        <div className="input-field">
                          <label>Phone Number</label>
                          <input
                            type="text"
                            placeholder="Phone"
                            value={
                              labData?.user?.phoneNumber
                                ? `+${labData.user.phoneNumber.dialCode} ${labData.user.phoneNumber.number}`
                                : "--"
                            }
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="input-group">
                        <div className="input-field">
                          <label>Email</label>
                          <input
                            type="text"
                            placeholder="Email"
                            value={
                              labData?.email || labData?.user?.email || "--"
                            }
                            readOnly
                          />
                        </div>
                        <div className="input-field">
                          <label>Address</label>
                          <textarea
                            className="input-address"
                            placeholder="Address"
                            value={labData?.information?.address.add || "--"}
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="input-group">
                        {labData?.information?.additionalText && (
                          <div className="input-field" style={{ width: "48%" }}>
                            <label>Additional Text</label>
                            <textarea
                              placeholder="Description"
                              value={
                                labData?.information?.additionalText || "--"
                              }
                              readOnly
                            ></textarea>
                          </div>
                        )}
                        {labData?.investigations && (
                          <div className="input-field">
                            <label>Tests Available</label>
                            <textarea
                              placeholder="Tests"
                              value={labData?.investigations
                                ?.map((test) => test.type)
                                .join(", ")}
                              readOnly
                            ></textarea>
                          </div>
                        )}
                        {/* <div className="input-field" style={{ width: "48%" }}>
                        <label>Specializations</label>
                        <textarea
                          placeholder="Specializations"
                          value={
                            labData?.specializations
                              ? labData.specializations.join(", ")
                              : "--"
                          }
                          readOnly
                        ></textarea>
                      </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {labData?.otherServices && (
                <div className="request-document">
                  <h4>Other Services</h4>
                  <div className="other-services-container">
                    {labData?.otherServices?.map((service, index) => (
                      <div className="service-card" key={index}>
                        {service}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {/* <div className="request-document-other">
              <h4>Investigations</h4>
              <div className="other-services-container">
                {labData?.investigations?.map((investigation, index) => (
                  <div className="service-card" key={index}>
                    <div
                      style={{
                        fontSize: "14px",
                        color: "#d58de8",
                        fontWeight: "500",
                      }}
                    >
                      {investigation.type}
                    </div>
                    <div
                      style={{
                        fontWeight: "600",
                        marginTop: "4px",
                        fontSize: "20.98px",
                      }}
                    >
                      {investigation.name}
                    </div>
                  </div>
                ))}
              </div>
            </div> */}

              {/* <div className="request-document">
              <h3>Professional Documents</h3>
              <div className="doc-main">
                <div>
                  {labData?.professionalDocuments?.certificate && (
                    <div className="doc">
                      <div className="doc-file">
                        <img
                          style={{ width: "100%", height: "100%" }}
                          src={labData?.professionalDocuments?.certificate}
                          alt=""
                        />
                      </div>
                      <div className="Document-name">
                        <span>
                          {labData?.professionalDocuments &&
                          Object.keys(labData.professionalDocuments).length > 0
                            ? Object.keys(labData.professionalDocuments)[0]
                            : "No document available"}
                        </span>
                      </div>
                    </div>
                  )}
                  {labData?.professionalDocuments?.license && (
                    <div className="doc">
                      <div className="doc-file">
                        <img
                          style={{ width: "100%", height: "100%" }}
                          src={labData?.professionalDocuments?.license}
                          alt=""
                        />
                      </div>

                      <div className="Document-name">
                        <span>
                          {labData?.professionalDocuments &&
                          Object.keys(labData.professionalDocuments).length > 1
                            ? Object.keys(labData.professionalDocuments)[1]
                            : "No document available"}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div> */}
              {labData?.investigations && labData.investigations.length > 0 && (
                <div className="request-document">
                  <h3>Investigations</h3>
                  <div className="other-services-container">
                    {labData?.investigations &&
                    labData.investigations.length > 0 ? (
                      labData.investigations.map((investigation, index) => (
                        <div className="service-card" key={index}>
                          <h4 className="service-name">
                            {investigation.name || "Name"}
                          </h4>
                          <p className="service-desc">
                            {investigation.information || "information"}
                          </p>
                          <p>
                            <span>
                              {" "}
                              <b> Price:</b>
                            </span>{" "}
                            {investigation.price || "0"}
                          </p>
                        </div>
                      ))
                    ) : (
                      <p style={{ color: "#888" }}>No services available</p>
                    )}
                  </div>
                </div>
              )}

              {labData?.documents && (
                <div className="request-document">
                  <h3>Professional Documents</h3>
                  <div className="doc-main">
                    <div>
                      {labData?.documents?.certificate && (
                        <div className="doc">
                          <div
                            className="doc-file"
                            onClick={() =>
                              setSelectedImage(labData?.documents?.certificate)
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={labData?.documents?.certificate}
                              alt=""
                            />
                          </div>
                          <div className="Document-name">
                            <span>
                              {labData?.documents &&
                              Object.keys(labData.documents).length > 0
                                ? Object.keys(labData.documents)[0]
                                : "No document available"}
                            </span>
                          </div>
                        </div>
                      )}
                      {labData?.documents?.license && (
                        <div className="doc">
                          <div
                            className="doc-file"
                            onClick={() =>
                              setSelectedImage(labData?.documents?.license)
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={labData?.documents?.license}
                              alt=""
                            />
                          </div>
                          <div className="Document-name">
                            <span>
                              {labData?.documents &&
                              Object.keys(labData.documents).length > 1
                                ? Object.keys(labData.documents)[1]
                                : "No document available"}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {labData?.personalDocuments && (
                <div className="request-document">
                  <h3>Personal Documents</h3>
                  <div className="doc-main">
                    <div>
                      {labData?.personalDocuments?.nimc && (
                        <div className="doc">
                          <div
                            className="doc-file"
                            onClick={() =>
                              setSelectedImage(labData?.personalDocuments?.nimc)
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={labData?.personalDocuments?.nimc}
                              alt=""
                            />
                          </div>
                          <div className="Document-name">
                            <span>NIMC</span>
                          </div>
                        </div>
                      )}
                      {labData?.personalDocuments?.license && (
                        <div className="doc">
                          <div
                            className="doc-file"
                            onClick={() =>
                              setSelectedImage(
                                labData?.personalDocuments?.license
                              )
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={labData?.personalDocuments?.license}
                              alt=""
                            />
                          </div>
                          <div className="Document-name">
                            <span>License</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      {selectedImage && (
        <ImagePreviewModal
          imageUrl={selectedImage}
          onClose={() => setSelectedImage(null)}
        />
      )}
    </>
  );
};

export default FacilityLabDetail;
